<template>
  <div class="grid-item"
    :class="getItemClass(assetModule)">
    <label class="grid-item__name">
      {{ assetModule.name }}
    </label>
    <div
      class="grid-item__status">
      <module-status-badge
        class="grid-item__status-badge"
        :value="assetModule.status"
      />
    </div>
    <div
      class="grid-item__self-diagnosis"
      v-if="shouldShowSelfDiagnosis">
      <i
        class="grid-item__self-diagnosis-icon fa fa-exclamation-circle"
        aria-hidden="true"
        v-b-tooltip.hover.right
        :title="$t('enums.module-self-diagnosis-status.with-self-diagnoses-activated')" />
    </div>
    <div
      v-else
      class="grid-item__last-reading">
      <label
        class="grid-item__last-reading-label">
        {{ $t('fields.digital-network.last-reading') }}
      </label>
      <date-time-label
        :value="assetModule.lastReadingTime"/>
    </div>
  </div>
</template>

<script>
import digitalNetworkItemMixin from '@/domain/mixins/generalPanel/mySigma/digitalNetworkItemMixin';
import ModuleStatusBadge from '../../networkStatus/ModuleStatusBadge';

export default {
  components: {
    ModuleStatusBadge,
  },
  mixins: [digitalNetworkItemMixin],
  methods: {
    getItemClass(assetModule) {
      return {
        [`grid-item__status_${assetModule.status}`]: true,
      };
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/components/badge-default-colors.sass"

  .grid-item
    margin: 1em
    display: flex
    flex-direction: column
    text-align: center
    border: 1px solid
    border-radius: .3em
    min-height: 10.5em
    padding: 1em 1em .5em 1em
    align-content: space-between
    &__status
      &_active
        border-color: $status-active
        color: $status-active
      &_inactive
        border-color: $status-inactive
        color: $status-inactive
        border-width: 2px
        background-color: rgba($status-inactive, .05)
        .grid-item
          &__last-reading
            color: $status-inactive
      &_disabled
        border-color: $status-disabled
        color: $status-disabled
      &_establishing-communication
        border-color: $status-establishing-communication
        color: $status-establishing-communication
      &_under-maintenance
        border-color: $status-under-maintenance
        color: $status-under-maintenance
      &_indeterminate
        border-color: $status-indeterminate
        color: $status-indeterminate
      &_partial-communication
        border-color: $status-partial-communication
        color: $status-partial-communication
    &__name
      min-height: 3em
    &__last-reading
      margin-top: .7em
    &__self-diagnosis
      margin-top: 1em
    &__self-diagnosis-input
      display: inline-flex
      max-width: 80%
    &__status-badge
      min-width: 7em
    &__last-reading-label
      display: block
      margin-bottom: 0
    &__last-reading,
    &__self-diagnosis
      color: var(--font-color-primary)
    &__self-diagnosis-icon
      color: var(--font-color-primary)

</style>
